export const getFallbackLoginPath = (): string => {
  const origin = location.origin;

  switch (origin) {
    case "https://localhost:3000":
    case "https://dev.fileops.com":
    case "https://test.fileops.com":
    case "https://demo.fileops.com":
      return `${origin}/fallbackauthdialog.html`;
    case "https://appstaging.fileops.com":
    case "https://app.fileops.com":
      return `${origin}/addin/fallbackauthdialog.html`;
  }
};
